var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('div',_vm._l((_vm.galleryContent),function(item,index){return _c(item.acf_fc_layout,{key:index,tag:"component",attrs:{"data":item,"isDownloadable":_vm.wpData.is_content_downloadable,"position":index}})})):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6629f294","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GalleryView.vue
// module id = 315
// module chunks = 1